import React from "react";
import { useClients } from "@/contexts/ClientContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function ClientPicker() {
  const { clients, selectedId, select } = useClients();
  if (!clients?.length) {
    return (
      <div className="text-xs text-zinc-500 label-overline" data-testid="no-clients-label">
        No clients yet
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3" data-testid="client-picker">
      <span className="label-overline">Client</span>
      <Select value={selectedId} onValueChange={select}>
        <SelectTrigger className="w-[260px] rounded-sm h-10" data-testid="client-picker-trigger">
          <SelectValue placeholder="Select a client" />
        </SelectTrigger>
        <SelectContent>
          {clients.map((c) => (
            <SelectItem key={c.client_id} value={c.client_id} data-testid={`client-option-${c.client_id}`}>
              {c.company_name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
